import { Component, signal } from '@angular/core';
import {Visuals} from './visuals/visuals';
import {HeaderNav} from './header-nav/header-nav';
import {SelectionsAccordion} from './selections-accordion/selections-accordion';

@Component({
  selector: 'app-root',
  imports: [Visuals, HeaderNav, SelectionsAccordion],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('cubecustomizer');
}
